import { AfterContentInit, Component } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-form-drop-exp',
  styleUrls: ['form-dropExp.component.scss'],
  template: `
    @if (props.label) {
      <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
      <label
        class="section w-100"
        tabindex="0"
        [class.mat-error]="formControl.errors && formControl.touched"
        [innerHTML]="props.label"
      >
        @if (props.required) {
          <sup>*</sup>
        }
      </label>
    }
    @if (props.prompt) {
      <p class="explanation" tabindex="0" [innerHTML]="props.prompt"></p>
    }

    <mat-form-field class="w-100">
      <mat-label>{{ to.placeholder }}</mat-label>
      <mat-select
        class="w-100"
        disableOptionCentering
        [formControl]="formControl"
        [placeholder]="props.placeholder || props.label"
        [formlyAttributes]="field"
        [required]="props.required"
        (selectionChange)="props.change ? to.change(field, formControl) : ''"
      >
        @for (opt of props?.options; track opt.value) {
          <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
        }
      </mat-select>
      @if (!props.required && formControl.value) {
        <button
          matSuffix
          mat-icon-button
          aria-label="Clear"
          color="warn"
          type="button"
          matTooltip="Clear Selection"
          (click)="clearSelection($event)"
        >
          <mat-icon class="clear-button-icon">close</mat-icon>
        </button>
      }
      @if (props.help) {
        <span
          matTooltip="{{ props.help }}"
          aria-label="help"
          tabindex="0"
          [matTooltipPosition]="'above'"
          [matTooltipClass]="'rb-tooltip'"
        >
          <mat-icon class="col-1 help-icon"> help </mat-icon>
        </span>
      }
      @if (
        formControl.hasError('required') && !formControl.hasError('regRequired')
      ) {
        <mat-error>This field is required</mat-error>
      }
      @if (formControl.hasError('regRequired')) {
        <mat-error>
          This field is needed for suitability review. You can opt out below if
          the applicant refuses to provide the information.
        </mat-error>
      }
    </mat-form-field>
  `,
  imports: [
    FormlyModule,
    MatSelectModule,
    MatIconModule,
    ReactiveFormsModule,
    MatTooltipModule,
    MatButtonModule,
  ],
})
export class FormlyDropExpComponent
  extends FieldType
  implements AfterContentInit
{
  dropExpOptions = [];

  ngAfterContentInit(): void {
    if (this.key === 'AnnuityWizard_TermToValidate') {
      this.props.options = this.field.parent.parent.model.multiTermOptions;
    }
  }
  clearSelection(ev): void {
    ev.preventDefault();
    ev.stopPropagation();
    this.formControl.setValue(null);
  }
}
